import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store, select } from '@ngrx/store';
import { PreferencesState } from '@purplefront/preferences/data-access';
import * as fromRouterStore from '../../../../../../app-router/data-access/src/lib/_store';

import { Observable, Subject, Subscription } from 'rxjs';
import { Catalog, CatalogState, catalogs } from '@purplefront/catalog/data-access';
import { AppRouterFacadeService } from '@purplefront/app-router/data-access';
import { take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-preferences-menu',
  templateUrl: './preferences-menu.component.html',
  styleUrls: ['./preferences-menu.component.scss']
})
export class PreferencesMenuComponent implements OnInit, OnDestroy {
  public currentPage: string;
  public catalogs$: Observable<Catalog[]>;
  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  private lang$: Observable<string>;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _store: Store<PreferencesState>,
    private _catalogStore: Store<CatalogState>,
    private _appRouterFacade: AppRouterFacadeService,
    private _routerStore: Store<fromRouterStore.AppRouterState>
  ) {}

  ngOnInit() {
    this.catalogs$ = this._catalogStore.pipe(select(catalogs));

    this._routerStore
      .select(fromRouterStore.selectContentLang)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((lang) => (this.lang$ = lang));
    /**
     * Get current route data
     */
    // let route = this.route;
    // while (route.firstChild) {
    //   route = route.firstChild;
    // }

    this._store
      .pipe(takeUntil(this.ngUnsubscribe$), select(fromRouterStore.selectCurrentSection))
      .subscribe((currentPage) => (this.currentPage = currentPage));
  }

  /**
   * Go to specific page
   */

  goToPage(page: string) {
    this._appRouterFacade.gotoPreferencesPage(this.lang$, { section: page });
  }

  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
